import { render } from "./MainCategory.vue?vue&type=template&id=18a76724&scoped=true"
import script from "./MainCategory.vue?vue&type=script&lang=js"
export * from "./MainCategory.vue?vue&type=script&lang=js"

import "./MainCategory.vue?vue&type=style&index=0&id=18a76724&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a76724"]])

export default __exports__